var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.propsMemberName)?_c('div',{staticClass:"text-right",attrs:{"id":"welcomeMsg"}},[_vm._v("\n  ようこそ！ "),_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.propsMemberName))]),_vm._v(" さん\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }